<div class="hrmParent">
  <div
    class="hrm"
    [style.backgroundImage]="'url(/assets/images/hrm2_' + zone + '.png)'"
  ></div>
  <div class="hrmIndex" [style.transform]="'rotate(' + angle + 'deg)'"></div>
  <div class="hrmStats">
    <h2>{{ avgHeart | number : "1.0-0" }}</h2>
    <div class="hearts">
      <ion-icon name="heart" [class]="'hrm' + zone"></ion-icon>
      <ion-icon name="heart-outline" class="hrm0"></ion-icon>
    </div>
  </div>
</div>
